/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Shoot_Share_Connect_1Inputs */

const en_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const es_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const fr_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const de_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ja_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const zh_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ar_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const id_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const it_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ru_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const pt_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

const ko_shoot_share_connect_1 = /** @type {(inputs: Shoot_Share_Connect_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Shoot Share Connect`)
};

/**
* | output |
* | --- |
* | "Shoot Share Connect" |
*
* @param {Shoot_Share_Connect_1Inputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const shoot_share_connect_1 = /** @type {((inputs?: Shoot_Share_Connect_1Inputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Shoot_Share_Connect_1Inputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_shoot_share_connect_1(inputs)
	if (locale === "es") return es_shoot_share_connect_1(inputs)
	if (locale === "fr") return fr_shoot_share_connect_1(inputs)
	if (locale === "de") return de_shoot_share_connect_1(inputs)
	if (locale === "ja") return ja_shoot_share_connect_1(inputs)
	if (locale === "zh") return zh_shoot_share_connect_1(inputs)
	if (locale === "ar") return ar_shoot_share_connect_1(inputs)
	if (locale === "id") return id_shoot_share_connect_1(inputs)
	if (locale === "it") return it_shoot_share_connect_1(inputs)
	if (locale === "ru") return ru_shoot_share_connect_1(inputs)
	if (locale === "pt") return pt_shoot_share_connect_1(inputs)
	return ko_shoot_share_connect_1(inputs)
});